import { TableAbstractExternalSyncStorage } from './TableAbstractExternalSyncStorage';
import { getFormattedStatementValue, getStatementValue } from '../../Table/Statements/StatementTableData';
import { RowType } from '../../Table/TableRow.interface';
export class StatementStorage extends TableAbstractExternalSyncStorage {
    constructor(statementProvider) {
        super();
        this._statementsMap = new Map();
        this._statementsProvider = statementProvider;
    }
    getStatement(row) {
        var _a;
        return (_a = this._statementsMap.get(row.id)) !== null && _a !== void 0 ? _a : null;
    }
    createRow(statement) {
        return {
            id: statement.getTradeId() || statement.getOperationId(),
            type: RowType.Row,
            data: {
                getValue: (columnId) => getStatementValue(statement, columnId),
                getFormattedValue: (columnId) => getFormattedStatementValue(statement, columnId)
            },
            disabled: false,
            children: []
        };
    }
    loadStatements(fromDate, toDate) {
        this.clearRows();
        const statements = this._statementsProvider.getStatements(fromDate, toDate);
        const statementRows = statements.map(statement => {
            const row = this.createRow(statement);
            this._statementsMap.set(row.id, statement);
            return row;
        });
        this.initializeRows(statementRows);
    }
    initialize() {
        const today = new Date();
        this.loadStatements(today, today);
    }
    onSubscribe() {
        this.initialize();
    }
    onUnsubscribe() {
        this.clearRows();
    }
}
